export const HeroSection: React.FC = () => {
  return (
    <section
      id="hero"
      className="hero-section relative overflow-hidden border-b py-20 px-4"
    >
      {/* Background construction imagery - Unsplash free license */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2000&q=80"
          alt="Construction crane and building site"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-50/90 via-white/95 to-white"></div>
      </div>
      <div className="container mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left column */}
        <div className="space-y-6">
          <p className="text-sm font-semibold text-violet-600 uppercase tracking-wide">
            Ageiro ARK · System of Intelligence
          </p>
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight">
            Created for the Built World.
          </h1>
          <p className="text-2xl text-slate-800 font-medium">
            Answers you can trust, and prompts that turn into action.
          </p>
          <p className="text-xl text-slate-700 leading-relaxed">
            Eliminate data silos and turn fragmented data into a powerful system of intelligence. Modern work has outgrown manual processing.
          </p>

          <div className="flex flex-wrap items-center gap-4 pt-4">
            <a href="https://www.ageiro.global/contact-sales" className="primary-cta px-6 py-3 rounded-xl text-base font-semibold shadow-lg hover:shadow-xl transition-shadow">
              Request a Demo
            </a>
            <button className="secondary-cta px-6 py-3 rounded-xl text-base font-semibold border-2 shadow-sm hover:shadow-md transition-shadow">
              View Capabilities
            </button>
          </div>
        </div>

        {/* Right column */}
        <div className="relative">
          {/* CAD/Blueprint overlay image - Unsplash free license */}
          <div className="absolute -top-8 -right-8 w-48 h-48 opacity-20 pointer-events-none hidden lg:block">
            <img
              src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=400&q=80"
              alt="Architectural blueprints"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
          <div className="mockup rounded-2xl border border-slate-200 shadow-xl bg-white p-6 relative">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
              <span className="ml-4 text-sm text-slate-500">Ageiro ARK · Chat</span>
            </div>
            <div className="rounded-lg border border-violet-200 bg-violet-50 p-4 text-sm mb-3">
              <span className="font-semibold text-violet-900">Question:</span> "What's the specified concrete strength for Level 2?"
            </div>
            <div className="rounded-lg border border-green-200 bg-green-50 p-4 text-sm">
              <span className="font-semibold text-green-900">ARK:</span> The specified concrete strength for Level 2 is 40 MPa, as per Section 03 30 00, paragraph 2.1.1. (Sheet S-210).
            </div>
          </div>

          {/* Hero connector strip */}
          <div className="mt-6">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
              Connects to Your Stack
            </p>
            <div className="flex flex-wrap gap-2 text-sm text-slate-600">
              <span className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1.5 font-medium">
                Autodesk Construction Cloud
              </span>
              <span className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1.5 font-medium">
                BIM 360
              </span>
              <span className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1.5 font-medium">
                SharePoint
              </span>
              <span className="inline-flex items-center rounded-full bg-slate-100 text-slate-700 px-3 py-1.5 font-medium">
                +more
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
